import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconDotsHorizontal } from '../../../../../base/icons/svg';
import Button from '../../../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../../../base/ui/constants.any';
const RoomActionEllipsis = ({ onClick }) => {
    const { t } = useTranslation();
    return (React.createElement(Button, { accessibilityLabel: t('breakoutRooms.actions.more'), icon: IconDotsHorizontal, onClick: onClick, type: BUTTON_TYPES.Transparent, noBorder: true, size: 'small' }));
};
export default RoomActionEllipsis;
